// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"Memories_backToTop__mbJWg"};